import { put, call } from 'redux-saga/effects';
import { projectCreateAPI, projectSearchAPI, projectUpdateAPI } from 'src/api/ProjectApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { PROJECT_ACTIONS } from '../actions/ProjectActions';
import { toast } from 'react-toastify';

function* search({
    where,whereOadCmd,dateRange=null, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(projectSearchAPI, {
            where,
            whereOadCmd,
            dateRange,
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: PROJECT_ACTIONS.PROJECT_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: PROJECT_ACTIONS.PROJECT_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
    userId,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(projectSearchAPI, {
            where: {
                _id,
                userId
            },
            pageLength: 1,
            currentPage: 0,
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: PROJECT_ACTIONS.PROJECT_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(projectCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Project Created")
        
        yield put({
            type: PROJECT_ACTIONS.PROJECT_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: PROJECT_ACTIONS.PROJECT_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: PROJECT_ACTIONS.PROJECT_UPSERT_ERROR,
        });
    }
}

function* update(ProjectId, payload) {
    try {
        yield call(projectUpdateAPI, {
            ProjectId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Project deleted")
        }
        else{
            toast("Project updated")
        } 
        
        yield put({
            type: PROJECT_ACTIONS.PROJECT_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: PROJECT_ACTIONS.PROJECT_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(PROJECT_ACTIONS.PROJECT_SEARCH, search),
    takeFirstSagaUtil(PROJECT_ACTIONS.PROJECT_UPSERT, upsert),
    takeFirstSagaUtil(PROJECT_ACTIONS.PROJECT_EDIT, edit),
];
